import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {buildHoverParentClassName} from '../../../../../../../libs/shared/core/src/helpers/browser/hoverHelpers';
import {KeyboardActionsEnum} from '../../../../../../../libs/shared/core/src/helpers/browser/keyboardHelpers';
import {ClickEventHandler} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {ChromelessButton} from '../../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {KeyboardEventHandlers} from '../../../../../../../libs/shared/ui/src/components/keyboard/keyboardContext';
import {KeyboardShortcuts} from '../../../../../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {TooltipCoordinator} from '../../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';

/*
 * Props.
 */

interface ConversationHeaderAiSummarizeWrapperProps {
  children: React.ReactNode;
  isButtonDisabled?: boolean;
  isButtonHidden?: boolean;
  onKeyCommand?: () => void;
  renderTooltip?: () => React.ReactNode;
  onClick?: ClickEventHandler;
}

/*
 * Style.
 */

const StyleSummaryContainerDiv = styled.div<{$isButtonDisabled?: boolean}>`
  display: grid;
  grid-template-columns: 6px 1fr 6px;
  grid-template-areas: '. banner-content .';
  width: 100%;
  height: fit-content;
  overflow: hidden;
  border-radius: 8px;

  ${(p) =>
    !p.$isButtonDisabled &&
    css`
      &:hover {
        transition: none;
        background-color: ${p.theme.greys.shade30};
      }
    `}
`;

const StyledTooltipCoordinator = styled(TooltipCoordinator)`
  width: 100%;
  grid-area: banner-content;
`;

const StyledAiSummarizeButton = styled(ChromelessButton)`
  background-color: transparent;
  display: grid;
  grid-template-areas:
    'left text . right'
    'content content . .';
  grid-template-columns: auto 1fr auto auto;

  padding: 4px;

  width: 100%;
`;

/*
 * Component.
 */

export const ConversationHeaderAiSummarizeWrapper: FC<ConversationHeaderAiSummarizeWrapperProps> = (
  props,
) => {
  const {children, isButtonDisabled, isButtonHidden, onClick, onKeyCommand, renderTooltip} = props;
  const keyHandlers: KeyboardEventHandlers = {
    [KeyboardActionsEnum.TOGGLE_EXPANDED_CONVERSATION_SUMMARY]: onKeyCommand,
  };

  return (
    <KeyboardShortcuts handlers={keyHandlers}>
      {!isButtonHidden && (
        <StyleSummaryContainerDiv
          $isButtonDisabled={isButtonDisabled}
          className={buildHoverParentClassName()}
        >
          <StyledTooltipCoordinator render={renderTooltip}>
            <StyledAiSummarizeButton onClick={onClick} isDisabled={isButtonDisabled}>
              {children}
            </StyledAiSummarizeButton>
          </StyledTooltipCoordinator>
        </StyleSummaryContainerDiv>
      )}
    </KeyboardShortcuts>
  );
};
